import { render } from "./Delivered.vue?vue&type=template&id=08e77204"
import script from "./Delivered.vue?vue&type=script&lang=js"
export * from "./Delivered.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__